module.exports = __webpack_public_path__ + "img/Stelle.f6c0cca9.svg";